// extracted by mini-css-extract-plugin
module.exports = {"base":"Main_base__HiaDm","Container":"Main_Container__3rVHR","Content":"Main_Content__2QKat"};